export default "__VITE_ASSET__B75O5nA2__"